import { render, staticRenderFns } from "./contentCard.vue?vue&type=template&id=5cd7b5e0&scoped=true&"
import script from "./contentCard.vue?vue&type=script&lang=js&"
export * from "./contentCard.vue?vue&type=script&lang=js&"
import style0 from "./contentCard.vue?vue&type=style&index=0&id=5cd7b5e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd7b5e0",
  null
  
)

export default component.exports